import {
	WORKER_INSTANCE_LOADING_TRUE,
	WORKER_INSTANCE_LOADING_FALSE,
	WORKER_INSTANCE_INFO_GET,
	WORKER_INSTANCE_INFO_ERROR,
	WORKER_INSTANCE_DATA_GET,
	WORKER_INSTANCE_DATA_ERROR,
	WORKER_INSTANCE_DATA_HISTORY_GET,
	WORKER_INSTANCE_DATA_HISTORY_ERROR,
	WORKER_INSTANCE_CONFIG_GET,
	WORKER_INSTANCE_CONFIG_ERROR,
	WORKER_INSTANCE_START_ERROR,
	WORKER_INSTANCE_STOP_ERROR,
	WORKER_INSTANCE_END_ERROR,
	WORKER_INSTANCE_CLEAN_ERROR,
	WORKER_INSTANCE_STATUS_HISTORY_GET,
	WORKER_INSTANCE_STATUS_HISTORY_ERROR,
	WORKER_INSTANCE_COMMANDS_LOADING,
	WORKER_INSTANCE_COMMANDS_GET,
	WORKER_INSTANCE_COMMANDS_ERROR,
	WORKER_INSTANCE_EVENTS_LOADING,
	WORKER_INSTANCE_EVENTS_GET,
	WORKER_INSTANCE_EVENTS_ERROR,
	WORKER_INSTANCE_EVENTS_COUNT_GET,
	WORKER_INSTANCE_EVENTS_COUNT_ERROR
} from '../actions/types';

const initialState = {
	worker_instance_loading: false,
	worker_instance: { info: {}, data: {}, config: {} },
	worker_instance_data_history: { count: 0, history: [] },
	worker_instance_status_history: { count: 0, history: [] },
	worker_instance_commands_loading: false,
	worker_instance_commands: { count: 0, commands: [] },
	worker_instance_events_loading: false,
	worker_instance_events: { count: 0, events: [] },
	worker_instance_errors: {}
}

export default function workerInstanceReducer(state = initialState, action){
	switch(action.type){
		case WORKER_INSTANCE_LOADING_TRUE:
			return {
				...state,
				worker_instance_loading: true
			}
		case WORKER_INSTANCE_LOADING_FALSE:
			return {
				...state,
				worker_instance_loading: false
			}
		case WORKER_INSTANCE_INFO_GET:
			delete state.worker_instance_errors.worker_instance_info
			return {
				...state,
				worker_instance: {
					...state.worker_instance,
					info: action.payload
				}
			}
		case WORKER_INSTANCE_DATA_GET:
			delete state.worker_instance_errors.worker_instance_data
			return {
				...state,
				worker_instance: {
					...state.worker_instance,
					data: action.payload
				}
			}
		case WORKER_INSTANCE_DATA_HISTORY_GET:
			delete state.worker_instance_errors.worker_instance_data_history
			return {
				...state,
				worker_instance_data_history: {
					count: action.payload.count,
					history: action.payload.data
				}
			}
		case WORKER_INSTANCE_CONFIG_GET:
			delete state.worker_instance_errors.worker_instance_config
			return {
				...state,
				worker_instance: {
					...state.worker_instance,
					config: action.payload
				}
			}
		case WORKER_INSTANCE_STATUS_HISTORY_GET:
			delete state.worker_instance_errors.worker_instance_status_history
			return {
				...state,
				worker_instance_status_history: {
					count: action.payload.count,
					history: action.payload.history
				}
			}
		case WORKER_INSTANCE_COMMANDS_LOADING:
			return {
				...state,
				worker_instance_commands_loading: action.payload
			}
		case WORKER_INSTANCE_COMMANDS_GET:
			delete state.worker_instance_errors.worker_instance_commands
			return {
				...state,
				worker_instance_commands: {
					count: action.payload.count,
					commands: action.payload.commands
				}
			}
		case WORKER_INSTANCE_EVENTS_LOADING:
			return { ...state, worker_instance_events_loading: action.payload }
		case WORKER_INSTANCE_EVENTS_GET:
			delete state.worker_instance_errors.worker_instance_events
			return {
				...state,
				worker_instance_events: {
					count: action.payload.count || (action.payload.events ? action.payload.events.length : 0),
					events: action.payload.events || action.payload
				}
			}
		case WORKER_INSTANCE_EVENTS_COUNT_GET:
			delete state.worker_instance_errors.worker_instance_events_count
			return {
				...state,
				worker_instance_events: {
					...state.worker_instance_events,
					count: action.payload.count || 0
				}
			}
		case WORKER_INSTANCE_INFO_ERROR:
		case WORKER_INSTANCE_DATA_ERROR:
		case WORKER_INSTANCE_DATA_HISTORY_ERROR:
		case WORKER_INSTANCE_CONFIG_ERROR:
		case WORKER_INSTANCE_START_ERROR:
		case WORKER_INSTANCE_STOP_ERROR:
		case WORKER_INSTANCE_END_ERROR:
		case WORKER_INSTANCE_CLEAN_ERROR:
		case WORKER_INSTANCE_STATUS_HISTORY_ERROR:
		case WORKER_INSTANCE_COMMANDS_ERROR:
		case WORKER_INSTANCE_EVENTS_ERROR:
		case WORKER_INSTANCE_EVENTS_COUNT_ERROR:
			return {
				...state,
				worker_instance_errors: {
					...state.worker_instance_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
